import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-100 text-center text-sm text-gray-600 p-2">
      © 2025 Company. All rights reserved.
    </footer>
  );
}
